module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/instagram/chapel_sns_04-e86a57fbab20b47cc99a7db10926b281.jpg";